import { createContext } from "react";

const partnersContext = createContext();

export default partnersContext;